module.exports = __webpack_public_path__ + "static/media/england_PNG721.22611755.png";